"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    _c = function c() {
  return (_c = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var c in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, c) && (e[c] = t[c]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    o = function o() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M19.5,15.106l2.4-2.4a1,1,0,0,0,0-1.414l-2.4-2.4V5.5a1,1,0,0,0-1-1H15.106l-2.4-2.4a1,1,0,0,0-1.414,0l-2.4,2.4H5.5a1,1,0,0,0-1,1V8.894l-2.4,2.4a1,1,0,0,0,0,1.414l2.4,2.4V18.5a1,1,0,0,0,1,1H8.894l2.4,2.4a1,1,0,0,0,1.414,0l2.4-2.4H18.5a1,1,0,0,0,1-1Z"
  }), r.createElement("path", {
    d: "M10,6.349a6,6,0,0,1,0,11.3,6,6,0,1,0,0-11.3Z"
  }));
},
    a = function a() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M19.491,15.106l2.4-2.4a1,1,0,0,0,0-1.414l-2.4-2.4V5.5a1,1,0,0,0-1-1H15.1L12.7,2.1a1,1,0,0,0-1.414,0l-2.4,2.4H5.491a1,1,0,0,0-1,1V8.894l-2.4,2.4a1,1,0,0,0,0,1.414l2.4,2.4V18.5a1,1,0,0,0,1,1H8.885l2.4,2.4a1,1,0,0,0,1.414,0l2.4-2.4h3.394a1,1,0,0,0,1-1Z"
  }), r.createElement("path", {
    d: "M11.491,6c4,0,6,2.686,6,6s-2,6-6,6Z"
  }));
},
    l = {
  left: 0,
  top: 8
},
    i = function i(e) {
  var n = e.onClick,
      c = r.useContext(t.ThemeContext),
      i = r.useContext(t.LocalizationContext),
      u = "dark" === c.currentTheme,
      h = i && i.theme ? u ? i.theme.switchLightTheme : i.theme.switchDarkTheme : u ? "Switch to the light theme" : "Switch to the dark theme";
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "theme-switch",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: h,
      onClick: n
    }, u ? r.createElement(a, null) : r.createElement(o, null)),
    content: function content() {
      return h;
    },
    offset: l
  });
},
    u = function u(e) {
  var n = e.children,
      c = r.useContext(t.ThemeContext);
  return (n || function (e) {
    return r.createElement(i, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick() {
      return c.setCurrentTheme("dark" === c.currentTheme ? "light" : "dark");
    }
  });
},
    h = function h(e) {
  var n = e.onClick,
      c = r.useContext(t.ThemeContext),
      l = r.useContext(t.LocalizationContext),
      i = "dark" === c.currentTheme,
      u = l && l.theme ? i ? l.theme.switchLightTheme : l.theme.switchDarkTheme : i ? "Switch to the light theme" : "Switch to the dark theme";
  return r.createElement(t.MenuItem, {
    icon: i ? r.createElement(a, null) : r.createElement(o, null),
    onClick: n
  }, u);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.DarkIcon = o, exports.LightIcon = a, exports.themePlugin = function () {
  var e = function e(_e) {
    return r.createElement(u, _c({}, _e));
  };

  return {
    SwitchTheme: e,
    SwitchThemeButton: function SwitchThemeButton() {
      return r.createElement(e, null, function (e) {
        return r.createElement(i, _c({}, e));
      });
    },
    SwitchThemeMenuItem: function SwitchThemeMenuItem(t) {
      return r.createElement(e, null, function (e) {
        return r.createElement(h, {
          onClick: function onClick() {
            e.onClick(), t.onClick();
          }
        });
      });
    }
  };
};